module.exports = __webpack_public_path__ + "static/img/B (32).3ff306e4.png";